import { SettingBase } from './base/setting-base';

export class Setting extends SettingBase { }